module.exports = __webpack_public_path__ + "img/T7A6697.f6181dae.jpg";